import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { SCLoader, SCPagination } from 'rollup-allspark';
import { formatDateExact } from '../../../../utils/format-date';
import { isEmpty } from '../../../../utils';
import {
  DEFAULT_PAGE_NO,
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_SIZES,
} from '../../../../config';

const CONTENT_MIN_HEIGHT = 280;
const centeredPlaceholderStyle = { minHeight: CONTENT_MIN_HEIGHT };

const OosTable = ({
  tableHeaderData,
  tableBodyData,
  listLoading,
  tableType,
  activeTab,
}) => {
  const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE_NO);
  const [currentSize, setCurrentSize] = useState(DEFAULT_PAGE_SIZE);
  const [paginatedTableRowData, setPaginatedTableRowData] = useState([]);

  const rows = Array.isArray(tableBodyData) ? tableBodyData : [];

  useEffect(() => {
    const indexOfLastPerm = currentPage * currentSize;
    const indexOfFirstPerm = indexOfLastPerm - currentSize;
    setPaginatedTableRowData(rows.slice(indexOfFirstPerm, indexOfLastPerm));
  }, [
    tableHeaderData,
    tableBodyData,
    listLoading,
    tableType,
    activeTab,
    currentPage,
    currentSize,
  ]);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setCurrentSize(size);
  };

  const renderLoader = (
    <div
      className="flex w-full items-center justify-center"
      style={centeredPlaceholderStyle}
    >
      <SCLoader lineWidth={5} diameter={50} />
    </div>
  );

  const renderNoData = (
    <div
      className="flex w-full items-center justify-center text-2xl text-grey-darker"
      style={centeredPlaceholderStyle}
    >
      No data found
    </div>
  );

  const pagination =
    !listLoading && !isEmpty(rows) ? (
      <SCPagination
        className="mt-4"
        total={rows.length}
        page={currentPage}
        size={currentSize}
        sizes={DEFAULT_PAGE_SIZES}
        onPageChange={handlePageChange}
      />
    ) : null;

  if (listLoading) {
    return (
      <div className="flex flex-col items-center mb-4 mt-4">{renderLoader}</div>
    );
  }

  if (isEmpty(rows)) {
    return (
      <div className="flex flex-col items-center mb-4 mt-4">{renderNoData}</div>
    );
  }

  const renderHeaderCol = (tableHeaderData || []).map((cell, index) => (
    <th
      key={`discount-header-cell-${index + 1}`}
      className="border-b border-grey p-3 text-xs font-semibold uppercase text-grey-darker text-left"
    >
      {cell.title}
    </th>
  ));

  const renderTableBodyRows = paginatedTableRowData.map((cell, index) => (
    <tr key={`discount-row-${index + 1}`}>
      <td className="px-3 py-3 border-b border-grey">
        {tableType === 'modifier' ? cell.modifier_title : cell.title}
      </td>
      {tableType === 'modifier' ? (
        <td className="px-3 py-3 border-b border-grey">
          {cell.modifier_group_title}
        </td>
      ) : null}
      {activeTab?.type === 'logs' ? (
        <>
          <td className="px-3 py-3 border-b border-grey">
            {!isEmpty(cell.start_time) ? formatDateExact(cell.start_time) : ''}
          </td>
          <td className="px-3 py-3 border-b border-grey">
            {!isEmpty(cell.end_time) ? formatDateExact(cell.end_time) : ''}
          </td>
        </>
      ) : null}
      <td className="px-3 py-3 border-b border-grey ">{cell.branch_title}</td>
      <td className="px-3 py-3 border-b border-grey ">{cell.brand_title}</td>
      <td className="px-3 py-3 border-b border-grey ">{cell.duration}</td>
    </tr>
  ));

  return (
    <div className="flex flex-col items-center mb-4 mt-4">
      <table className="table-auto w-full mb-4">
        <thead>
          <tr>{renderHeaderCol}</tr>
        </thead>
        <tbody>{renderTableBodyRows}</tbody>
      </table>
      {pagination}
    </div>
  );
};

OosTable.propTypes = {
  tableHeaderData: PropTypes.array,
  tableBodyData: PropTypes.array,
  listLoading: PropTypes.bool,
  tableType: PropTypes.string,
  activeTab: PropTypes.object,
};

export default OosTable;
